import type { Interest } from '../types/contact';

export const LOGO_URL =
  'https://assets.cdn.filesafe.space/CsfHedhhmiHrpQT8qQjB/media/919bc254-8239-437c-ba28-b8b4ab5e76c3.png';
export const ICON_URL =
  'https://assets.cdn.filesafe.space/CsfHedhhmiHrpQT8qQjB/media/0fb25228-0fc2-41ea-85b1-68a3dcfdc31d.png';

export const contactInfo = {
  phoneDisplay: '(702) 509-6825',
  phoneHref: 'tel:+17025096825',
  smsHref: 'sms:+17025096825?&body=START',
  email: 'Results@DavidMoceri.com',
  emailHref: 'mailto:Results@DavidMoceri.com',
};

export const utilityLinks = [
  { label: 'Resources', href: 'https://davidmoceri.com/resources/' },
  { label: 'Recommended Services', href: 'https://davidmoceri.com/recommended-services/' },
  { label: 'Glossary', href: 'https://davidmoceri.com/seo-glossary/' },
  { label: 'Log In', href: 'https://davidmoceri.com/wp-login.php' },
];

export const mainNav = [
  { label: 'About', href: '#about' },
  { label: 'What I Do', href: '#what-i-do' },
  { label: 'Speaking', href: '#speaking' },
  { label: 'Consulting', href: '#consulting' },
  { label: 'Blog', href: 'https://davidmoceri.com/blog/' },
];

export const footerQuickLinks = [
  { label: 'About', href: '#about' },
  { label: 'What I Do', href: '#what-i-do' },
  { label: 'Speaking', href: '#speaking' },
  { label: 'Consulting', href: '#consulting' },
  { label: 'Blog', href: 'https://davidmoceri.com/blog/' },
  { label: 'Contact', href: '#contact' },
];

export const legalLinks = [
  { label: 'Privacy Policy', href: 'https://davidmoceri.com/privacy-policy/' },
  { label: 'Terms of Use', href: 'https://davidmoceri.com/terms-of-use/' },
  { label: 'Disclaimers', href: 'https://davidmoceri.com/disclaimers/' },
  {
    label: 'Do not sell or share my personal information',
    href: 'https://privacycenter.cytrio.com/davidmoceri-3a7yvs',
  },
];

export const interestOptions: Interest[] = [
  'Speaking',
  'Consulting',
  'Partnering',
  'Ad ROI Marketing',
  '1Dash.Pro',
  'Living Websites',
  'Other',
];
